import React from "react";

interface Props {
  height?: string | number;
  width?: string | number;
}

const RemisedPriceDropIcon: React.FC<Props> = ({ height = "auto", width = "auto" }) => {
  return (
    <svg
      style={{ height, width }}
      xmlns="http://www.w3.org/2000/svg"
      width="269"
      height="234"
      viewBox="0 0 269 234"
      fill="none">
      <circle cx="134.501" cy="116.501" r="101.501" fill="#EB002D" />
      <path
        d="M134.5 176.997C133.499 176.997 132.497 176.842 131.573 176.531C130.648 176.22 129.801 175.677 129.031 174.9L78.2663 123.568C76.7256 122.015 75.9553 120.151 75.9553 118.054C75.9553 115.957 76.7256 114.093 78.2663 112.54C79.8069 110.987 81.5787 110.21 83.6586 110.21C85.7384 110.21 87.5102 110.987 89.0508 112.54L126.797 150.593V63.6152C126.797 61.4407 127.567 59.5769 129.031 58.1791C130.494 56.7812 132.343 56.0046 134.5 56.0046C136.657 56.0046 138.506 56.7812 139.969 58.2567C141.433 59.7323 142.203 61.5961 142.203 63.7705V150.593L179.949 112.54C181.49 110.987 183.261 110.21 185.341 110.21C187.421 110.21 189.193 110.987 190.734 112.54C192.274 114.093 193.045 115.957 193.045 118.054C193.045 120.151 192.274 122.015 190.734 123.568L139.892 174.822C139.122 175.599 138.275 176.143 137.35 176.453C136.426 176.764 135.501 176.919 134.423 176.919L134.5 176.997Z"
        fill="white"
      />
    </svg>
  );
};

export default RemisedPriceDropIcon;
